import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { RotateCcw, ArrowRight } from 'lucide-react';
import { useRMACart } from '../../context/RMACartContext';

export function RMACartFloating() {
  const navigate = useNavigate();
  const location = useLocation();
  const { totalUnits, totalLines } = useRMACart();

  // Nascondiamo il floating sulla pagina del carrello stesso
  const hidden = location.pathname.includes('/area-clienti/rma/preparazione');

  if (totalUnits === 0 || hidden) return null;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-30 animate-[fadeIn_.25s_ease]" data-testid="rma-cart-floating">
      <button
        onClick={() => navigate('/area-clienti/rma/preparazione')}
        className="group bg-[hsl(214,58%,41%)] text-white rounded-full shadow-xl hover:bg-[hsl(214,58%,46%)] hover:shadow-2xl p-3 sm:pl-4 sm:pr-5 sm:py-3 flex items-center gap-3 transition-all"
        aria-label="Reso in preparazione"
        data-testid="rma-cart-floating-btn"
      >
        <div className="relative">
          <RotateCcw className="w-5 h-5" />
          <span className="absolute -top-2 -right-2 bg-emerald-500 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center border-2 border-white">
            {totalUnits}
          </span>
        </div>
        <div className="text-left leading-tight hidden sm:block">
          <div className="text-xs font-semibold">Reso in preparazione</div>
          <div className="text-[10px] opacity-80">{totalUnits} {totalUnits === 1 ? 'pezzo' : 'pezzi'} · {totalLines} {totalLines === 1 ? 'articolo' : 'articoli'}</div>
        </div>
        <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity hidden sm:block" />
      </button>
    </div>
  );
}
